import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import {
  LinkConsentsDialog,
  LinkConsentsDialogCallbackInput,
  LinkConsentsDialogUniqueProps,
} from '../link-consents-dialog';

const { useDialogForContext, useDialog: useLinkConsentsDialog } =
  getDialogHooks<
    LinkConsentsDialogUniqueProps,
    LinkConsentsDialogCallbackInput
  >(LinkConsentsDialog);

export const useLinkConsentsDialogForContext = useDialogForContext;
export default useLinkConsentsDialog;
